import { render, staticRenderFns } from "./ExpenseEdit.vue?vue&type=template&id=2273282a&scoped=true"
import script from "./ExpenseEdit.vue?vue&type=script&lang=js"
export * from "./ExpenseEdit.vue?vue&type=script&lang=js"
import style0 from "./ExpenseEdit.vue?vue&type=style&index=0&id=2273282a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273282a",
  null
  
)

export default component.exports